<template>
  <div class="filter-tags" v-if="filters.subject || filters.keyword">
    <p class="filter-row" v-if="filters.subject">
      Subject:
      <span class="filter-display">
        {{ filters.subject }}
        <i
          class="fa fa-close"
          @click="clearFilter('subject')"
          @keyup.enter="clearFilter('subject')"
          tabindex="0"
        />
      </span>
      <span
        v-if="filters.subjectDomain"
        class="filter-display">
        {{ filters.subjectDomain }}
        <i
          class="fa fa-close"
          @click="clearFilter('subjectDomain')"
          @keyup.enter="clearFilter('subjectDomain')"
          tabindex="0"
        />
      </span>
    </p>
    <p
      class="filter-row"
      v-if="filters.grades.length > 0">
      Grades:
      <span
        :key="grade"
        v-for="grade in gradesAsArray"
        class="filter-display">
        {{ getGradeLabel(grade) }}
        <i
          class="fa fa-close"
          @click="clearFilter('grades', grade)"
          @keyup.enter="clearFilter('grades', grade)"
          tabindex="0"
        />
      </span>
    </p>
    <p
      class="filter-row"
      v-if="filters.keyword">
      Keywords:
      <span
        class="filter-display">
        {{ filters.keyword }}
        <i
          class="fa fa-close"
          @click="clearFilter('keyword')"
          @keyup.enter="clearFilter('keyword')"
          tabindex="0"
        />
      </span>
    </p>
    <p
      class="filter-row"
      v-if="filters.standard">
      Standard:
      <span
        class="filter-display">
        {{ filters.standard }}
        <i
          class="fa fa-close"
          @click="clearFilter('standard')"
          @keyup.enter="clearFilter('standard')"
          tabindex="0"
        />
      </span>
    </p>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { gradeSort, gradeLabel } from '@/util/gradesort'
import { PremiumLocksMixin } from '@/contentprofile/premium_locks_mixin'

export default {
  name: 'BrowseGoalsFiltersDisplay',
  mixins: [PremiumLocksMixin],
  data() {
    return {}
  },
  props: {
    query: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  computed: {
    ...mapGetters({
      rawFilters: 'browse/filters'
    }),
    gradesAsArray() {
      if (this.filters.grades && !Array.isArray(this.filters.grades)) {
        return [this.filters.grades]
      }
      return this.sortGrades(this.filters.grades)
    },
    filters() {
      return this.filterLockedBrowseGoalsState(this.rawFilters)
    }
  },
  methods: {
    getGradeLabel(grade) {
      return gradeLabel(grade)
    },
    clearFilter(filter, grade) {
      let newQuery = Object.assign({}, this.query)
      switch (filter) {
        case 'subject':
          this.$sendEvent('Removed Browse Goals Subject', {
            browse_goals_removed_subject: newQuery.subject,
            browse_goals_removed_category: newQuery.subjectDomain,
            browse_goals_removed_standard: newQuery.standard
          })

          delete newQuery.subject
          delete newQuery.subjectDomain
          delete newQuery.standard
          break
        case 'subjectDomain':
          this.$sendEvent('Removed Browse Goals Category', {
            browse_goals_removed_category: newQuery.subjectDomain
          })

          delete newQuery.subjectDomain
          break
        case 'grades':
          this.$sendEvent('Removed Browse Goals Grade', {
            browse_goals_removed_grade: grade
          })

          newQuery.grades = this.gradesAsArray.filter(elem => elem !== grade)
          if (newQuery.grades.length === 0) delete newQuery.grades

          break
        case 'keyword':
          this.$sendEvent('Removed Browse Goals Keyword', {
            browse_goals_removed_keyword: newQuery.keyword.slice(0, 120) // limit length due to max size of field in db
          })

          delete newQuery.keyword
          break
        case 'standard':
          this.$sendEvent('Removed Browse Goals Standard', {
            browse_goals_removed_standard: newQuery.standard
          })

          delete newQuery.standard
          break
      }

      this.$router.replace({
        query: newQuery
      })
    },
    sortGrades(grades) {
      return gradeSort(grades)
    }
  }
}
</script>

<style lang="less" scoped>
@import '~@/variables.less';
.filter-display {
  background-color: @blueLight;
  padding: 5px 10px 5px 8px;
  border-radius: 5px;
  border: solid 1px @blue;
  margin: 5px 5px;
}
.filter-row {
  margin-bottom: 15px;
}
i.fa-close {
  color: @blue;
  cursor: pointer;
  margin-left: 7px;
}
.filter-tags {
  border-bottom: 2px solid @gray-lighter;
  margin-bottom: 10px;
}
</style>
